import serverVars from 'server-vars';
import { sessionStorage } from 'dibs-browser-storage';
import { getBuyerId } from 'dibs-cookie-jar';
import { VisitCountModel } from 'dibs-visit-tracking/exports/visitCountModel';
import { getStoredTradeFirmId } from '../utils/userTracking';
import authModalLoader from '../utils/AuthModalLoader';

export const UTM_SOURCE_KEY = 'utm_source';
export const UTM_CAMPAIGN_KEY = 'utm_campaign';
export const UTM_CONTENT_KEY = 'utm_content';

export const TRADE_UTM_LOCAL_STORAGE_KEY = 'isUtmTrade';
export const TRADE_AUTH_MODAL_SEEN_STORAGE_KEY = 'tradeAuthModalShown';

const TRADE = 'trade';
const SUSPECTED = 'suspected';
const APPLICATION = 'application';

const utmParamKeys = [UTM_SOURCE_KEY, UTM_CAMPAIGN_KEY, UTM_CONTENT_KEY];

const utmIncludesParam = (curKey, accVal, targetParam) => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get(curKey)) {
        return accVal || searchParams.get(curKey).includes(targetParam);
    }
    return accVal;
};

export const isUtmTrade = () => {
    const utmIncludesTrade = utmParamKeys.reduce((accTradeVal, curKey) => {
        return utmIncludesParam(curKey, accTradeVal, TRADE);
    }, false);
    const utmIncludesSuspected = utmParamKeys.reduce((accSuspectedVal, curKey) => {
        return utmIncludesParam(curKey, accSuspectedVal, SUSPECTED);
    }, false);
    const utmCampaignIncludesApplication = utmParamKeys[UTM_CAMPAIGN_KEY] === APPLICATION;
    const utmTradeValue =
        utmIncludesTrade && !utmIncludesSuspected && !utmCampaignIncludesApplication;

    return utmTradeValue;
};

export const isLoggedOutTrade = () => {
    if (getBuyerId(document.cookie)) {
        return false;
    }

    switch (true) {
        case !!getStoredTradeFirmId() && getStoredTradeFirmId() !== 'undefined':
            return true;
        case !!sessionStorage.getItem(TRADE_UTM_LOCAL_STORAGE_KEY):
            return true;
        default:
            return false;
    }
};

export const hasUserSeenTradeLogin = () => {
    return sessionStorage.getItem(TRADE_AUTH_MODAL_SEEN_STORAGE_KEY);
};

export const isTradeLoginDisabled = () => serverVars.get('enablers.isTradeAutoLoginModalDisabled');

export const shouldShowTradeLogin = () => {
    if (isTradeLoginDisabled()) {
        return false;
    }

    const visitCountModel = new VisitCountModel();
    const isAtSessionCount =
        visitCountModel.get('session') === visitCountModel.get('regPromptLimit');

    return isLoggedOutTrade() && isAtSessionCount;
};

export const initTradeLogin = () => {
    const { constants } = authModalLoader;

    sessionStorage.setItem(TRADE_AUTH_MODAL_SEEN_STORAGE_KEY, true);

    authModalLoader.show({
        action: constants.LOGIN,
        flow: constants.LOGGED_OUT_TRADE_FLOW,
        ga: {
            label: 'third pageview trade login',
        },
        fireEntryGa: true,
    });
};
